export enum FnsCheckStatusesEnum {
  NOT_FOUND = 'NOT_FOUND',
  FOUND = 'FOUND',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_DATA_56 = 'NO_DATA_56',
  NO_DATA_53 = 'NO_DATA_53',
  NO_DATA_MSP = 'NO_DATA_MSP',
  DATA_NOT_EQUALS_ERVK = 'DATA_NOT_EQUALS_ERVK',
}
